"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Providers;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _AdapterDateFns = _interopRequireDefault(require("@mui/lab/AdapterDateFns"));
var _LocalizationProvider = _interopRequireDefault(require("@mui/lab/LocalizationProvider"));
var _material = require("@mui/material");
var _colors = require("@mui/material/colors");
var dateFsnLocales = _interopRequireWildcard(require("date-fns/locale"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _reactIntl = require("react-intl");
var _utils = require("../../utils");
var _CleverApplicationContext = require("./CleverApplicationContext");
var _CssBaseline;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/locale-data/en'); // Add locale data for de
}
if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/locale-data/en'); // Add locale data for de
}
var defaultTheme = {
  components: {
    MuiAutocomplete: {
      inputRoot: {
        paddingRight: 39
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        groupedTextDefault: {
          color: 'inherit'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          margin: 1
        }
      }
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: {
          padding: 8
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          '&:not([data-shrink="true"])': {
            '&.MuiInputLabel-sizeSmall': {
              transform: 'translate(14px, 8px) scale(1)'
            },
            '&:not(.MuiInputLabel-sizeSmall)': {
              transform: 'translate(14px, 13px) scale(1)'
            }
          },
          '&[data-shrink="true"]': {
            borderRadius: '4px',
            marginLeft: '-5px',
            padding: '0px 7px'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '13px 14px'
        },
        inputMultiline: {
          padding: 0
        },
        inputSizeSmall: {
          padding: '8.5px 14px'
        },
        multiline: {
          padding: '13px 14px'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minWidth: 160,
          padding: '6px 16px'
        }
      }
    }
  },
  mixins: {
    mainMenu: {
      collapsedDrawerWidth: 57,
      drawerWidth: 230
    },
    table: {
      action: {
        maxWidth: 50
      },
      boolean: {
        maxWidth: 70
      },
      clear: {
        maxWidth: 60
      },
      datetime: {
        maxWidth: 175
      },
      icon: {
        maxWidth: 70
      },
      id: {
        maxWidth: 67
      },
      locale: {
        maxWidth: 70
      },
      multilineDatetime: {
        maxWidth: 110
      },
      narrowText: {
        maxWidth: 140
      },
      numberInput: {
        maxWidth: 140
      },
      reorder: {
        maxWidth: 75
      },
      row: {
        '@media only screen and (max-width: 959px)': {
          display: 'none'
        },
        maxWidth: 50,
        textAlign: 'center'
      },
      title: {
        maxWidth: 250
      }
    }
  },
  palette: {
    background: {
      default: '#f5f5f5'
    },
    black: {
      main: 'rgba(0, 0, 0, 0.87)'
    },
    colorDefault: '#ffffff',
    default: {
      contrastText: 'rgba(0, 0, 0, 0.87)',
      dark: _colors.grey[400],
      divider: 'rgba(0, 0, 0, 0.23)',
      light: 'rgba(0, 0, 0, 0.87)',
      main: _colors.grey[300]
    },
    error: {
      main: '#ED1B2F'
    },
    mode: 'light',
    primary: {
      light: '#C1E6FF',
      main: '#0077C8'
    },
    secondary: {
      contrastText: '#ffffff',
      main: '#00B001'
    },
    warning: {
      main: '#E49C00'
    }
  },
  typography: {
    h6: {
      fontWeight: 400
    }
  },
  userAgent: typeof navigator !== 'undefined' && navigator.userAgent || 'all'
};
var muiTheme = (0, _material.createTheme)((0, _extends2.default)({}, defaultTheme, {
  isDark: function isDark() {
    return false;
  }
}));
var muiThemeDark = (0, _material.createTheme)((0, _utils.mergeDeep)(defaultTheme, {
  isDark: function isDark() {
    return true;
  },
  palette: {
    background: {
      default: '#212121',
      paper: '#343434'
    },
    mode: 'dark'
  }
}));
var muiComponentVariants = function muiComponentVariants(theme) {
  return {
    components: {
      MuiButton: {
        styleOverrides: {
          contained: {
            boxShadow: 'none'
          },
          containedPrimary: {
            '&[enhance="ghost"]:not(.Mui-disabled):hover': {
              backgroundColor: 'rgba(0, 83, 140, 0.2)',
              boxShadow: 'none',
              color: '#0077C8'
            },
            '&[enhance="ghost"]:not(.Mui-disabled):not(:hover)': {
              backgroundColor: 'rgba(0, 119, 200, 0.12)',
              color: '#0077C8'
            }
          }
        },
        variants: [{
          props: {
            color: 'default',
            variant: 'contained'
          },
          style: {
            color: theme.palette.getContrastText(theme.palette.grey[300])
          }
        }, {
          props: {
            color: 'default',
            variant: 'outlined'
          },
          style: {
            '&.Mui-disabled': {
              border: "1px solid ".concat(theme.palette.action.disabledBackground)
            },
            '&:hover': {
              backgroundColor: (0, _material.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
              borderColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'
            },
            borderColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
            color: theme.palette.text.primary
          }
        }, {
          props: {
            color: 'default',
            variant: 'text'
          },
          style: {
            '&:hover': {
              backgroundColor: (0, _material.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            color: theme.palette.text.primary
          }
        }, {
          props: {
            color: 'black',
            variant: 'text'
          },
          style: {
            '&:hover': {
              backgroundColor: (0, _material.alpha)(theme.isDark() ? theme.palette.colorDefault : theme.palette.black.main, theme.palette.action.hoverOpacity)
            },
            color: theme.isDark() ? theme.palette.colorDefault : theme.palette.black.main
          }
        }]
      }
    }
  };
};
function Providers(_ref) {
  var children = _ref.children,
    darkMode = _ref.darkMode,
    _ref$IntlProviderProp = _ref.IntlProviderProps,
    IntlProviderProps = _ref$IntlProviderProp === void 0 ? {} : _ref$IntlProviderProp,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en' : _ref$locale,
    translations = _ref.translations;
  var theme = darkMode ? muiThemeDark : muiTheme;
  var dateFsnLocale = (0, _react.useMemo)(function () {
    var language = locale.slice(0, 2);
    var _locale$split = locale.split('-'),
      _locale$split2 = (0, _slicedToArray2.default)(_locale$split, 2),
      region = _locale$split2[1];
    return dateFsnLocales["".concat(language).concat(region)] || dateFsnLocales[language] || dateFsnLocales.enUS;
  }, [locale]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _CssBaseline || (_CssBaseline = /*#__PURE__*/_react.default.createElement(_material.CssBaseline, null)), /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, (0, _extends2.default)({
    key: locale,
    locale: locale,
    messages: translations[locale]
  }, IntlProviderProps), /*#__PURE__*/_react.default.createElement(_material.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_material.ThemeProvider, {
    theme: (0, _material.createTheme)(theme, muiComponentVariants(theme))
  }, /*#__PURE__*/_react.default.createElement(_LocalizationProvider.default, {
    dateAdapter: _AdapterDateFns.default,
    locale: dateFsnLocale
  }, /*#__PURE__*/_react.default.createElement(_CleverApplicationContext.CleverApplicationProvider, {
    locale: locale
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.default, {
    htmlAttributes: {
      lang: locale
    }
  }), children))))));
}